import React,{useContext,useState} from "react";
import style from "../../../styles/mystyle.module.css";
import MealsCard from "./MealsCard";
import Basket from "./Basket";
import { useTranslation } from "next-i18next";
import { getImage } from '../../helpers/images'
import { useMedia } from "../../../utils/use-media";
import CurrencyContext from '../../../context/currencyProvider'
function AllMealsCards(props) {
  const { t } = useTranslation("common");
  const mobile = useMedia("(max-width: 580px)");
  let products;
  let Basketproducts;
  if (props.products && props.products.length > 0) {
    products = props.products;
  }
  if (props.Basketproducts && props.Basketproducts.length > 0) {
    props.Basketproducts.map(a=>{
      if(a.OtherUnitsPrice &&a.OtherUnitsPrice.length){
        a.productUnitPrice=a.productUnitPrice.concat(a.OtherUnitsPrice)
        a.productUnitPrice=a.productUnitPrice.filter(
          (s, x) => x === a.productUnitPrice.findIndex(w => w.id === s.id))
        return a
      }
  
    })
    Basketproducts=props.Basketproducts
}
  const currency=useContext(CurrencyContext)

    const [imageLst,setImageLst]=useState([])
    React.useEffect(()=>{

      props.products?.pages.map((elements)=>elements&&elements.data.data.data.map((ele,index)=>{
        
        ele.productImages.map(async d => {
            if (d.files) {
              let fileString = d.files.filePath
              let rest = fileString.substring(0, fileString.lastIndexOf("/") + 1)
              let last = fileString.substring(fileString.lastIndexOf("/") + 1, fileString.length)
              let fileThumbnai = (rest + "thumbnail250/" + last)
              let img=await getImage(d.files.fileId, fileThumbnai)
              d.image = img
              d.productId=ele.id
              setImageLst(prev=>[...prev,d])
              return d
            }
          })
      
      }))
    },[props.products])
    
    const content= props.products?.pages.map((elements)=>elements&&elements.data.data.data.map((ele,index)=><MealsCard 
    product={ele} 
    image={imageLst.find(d=>d.productId==ele.id)}
    entityId={props.entityId}  
    showFavortie={true}
    currency={currency}
    key={index}
    />))
  return (
    <div>
      <div className={style.allcard}>
  
        <div className={style.CardandBasket}>
          <div className={style.fullwidth}>
  
          {mobile ? " " :   <Basket entityId={props.entityId} WorkTime={props.WorkTime} 
             products={Basketproducts}
             Open={props.Open}
             entityDetails={props.entityDetails}
            />}
          </div>
          <div className={style.marginRestuarntCard}>
              {content}
          {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllMealsCards;




